import createContext from '@ant-design/create-react-context';
var MenuContext = createContext({
  inlineCollapsed: false
});
export default MenuContext;
//# sourceMappingURL=MenuContext.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/menu/MenuContext.js
// module id = 273
// module chunks = 0